import { render, staticRenderFns } from "./card-slider-rivoneed.vue?vue&type=template&id=28e3232b&scoped=true&"
import script from "./card-slider-rivoneed.vue?vue&type=script&lang=js&"
export * from "./card-slider-rivoneed.vue?vue&type=script&lang=js&"
import style0 from "./card-slider-rivoneed.vue?vue&type=style&index=0&id=28e3232b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e3232b",
  null
  
)

export default component.exports